<template>
  <div id="registration">
    <app-nav></app-nav>
  </div>
</template>
<script>
  import api from "@/api/index";
  import SdNav from "../../components/shenduNav/SdNav";
  import { isMiniProgamme } from '@/common/util.js'
  export default {
    components: {
      "app-nav": SdNav
    },
    data() {
      return {};
    },
    created() {
      isMiniProgamme().then(res => {
        res == true ? this.$router.push('/SdSeeDoctor') : ''
      });
      localStorage.getItem('token') ? this.goRegist() : this.$router.push({
        path: "/SdLogin",
        query: {
          redirect: this.$route.fullPath, // 登录后自动跳到这页
          loginFrom: ''
        }
      });
    },
    methods: {
      goRegist() {
        this.$dialog
          .confirm({
            getContainer: "#registration",
            title: "温馨提示：",
            message: "挂号服务由第三方平台提供，您确定要前往“健康160”进行挂号吗？"
          })
          .then(() => {
            this.getRginfo()
              .then(this.getCount())
              .then(res => {
                window.location.href = res.data.url;
              })
          })
          .catch(() => {
            this.$router.push("/");
          });
      },
      getRginfo() {
        return new Promise((resolve, reject) => {
          this.$http.get(api.goRegist).then(res => {
            if (res.data.code == 0) {
              resolve(res);
            } else {
              reject(res);
            }
          });
        });
      },
      getCount() {
        return new Promise((resolve, reject) => {
          this.$http.get(api.rgsStatistic).then(res => {
            if (res.data.code == 0) {
              resolve(res);
            } else {
              reject(res);
            }
          });
        });
      }
    }
  };
</script>
<style lang="less">
  #registration {
    .van-dialog {
      height: unset;
      .van-dialog__header {
        font-size: 30px;
      }
      .van-dialog__message {
        font-size: 30px;
        line-height: 40px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdGoRegist.vue